import iSportMarketing from "../../../assets/icons/services-block/sport-marketing.svg";
import iSportMarketingBg from "../../../assets/icons/services-block/sport-marketing-bg.svg";
import iConsumerPromo from "../../../assets/icons/services-block/consumer-promo.svg";
import iConsumerPromoBg from "../../../assets/icons/services-block/consumer-promo-bg.svg";
import iEventMarketing from "../../../assets/icons/services-block/event-marketing.svg";
import iEventMarketingBg from "../../../assets/icons/services-block/event-marketing-bg.svg";
import { useNavigate } from "react-router-dom";
import Button from "../button/button";
import { paths } from "../../../routes/paths";
import { ReactNode } from "react";
import "./service-card.sass";

type ServiceCardName = "event-marketing" | "sport-marketing" | "consumer-promotion";

type Props = {
  title: string;
  children: ReactNode;
  name: ServiceCardName;
};

const SERVICE_CARD_ASSETS: Record<
  ServiceCardName,
  { illustration: string; background: string }
> = {
  "event-marketing": {
    illustration: iEventMarketing,
    background: iEventMarketingBg,
  },
  "sport-marketing": {
    illustration: iSportMarketing,
    background: iSportMarketingBg,
  },
  "consumer-promotion": {
    illustration: iConsumerPromo,
    background: iConsumerPromoBg,
  },
};

const ServiceCard = ({ title, children, name }: Props) => {
  const navigate = useNavigate();
  const { illustration, background } = SERVICE_CARD_ASSETS[name];

  return (
    <div className={`service-card ${name}`}>
      <div className="service-card__block">
        <div>
          <div className="service-card__title">{title}</div>
          <div className="service-card__text">{children}</div>
        </div>
        <Button
          className="service-card__button"
          onClick={() => navigate(`/${paths.ServicesPage}/${name}`)}
        >
          Подробнее
        </Button>
      </div>

      <img
        src={illustration}
        className="img-absolute service-card__media"
        alt=""
      />
      <img
        src={background}
        className="img-absolute service-card__media-bg"
        alt=""
      />
    </div>
  );
};

export default ServiceCard;
